import type { DocumentsResponse, UsersResponse } from "./schemas";

/**
 * Dev/review fixture data (ISSUE-329 Deliverable D, step 10). The two list
 * views rendered this until Deliverable D2 (step 16) wired `src/api/client.ts`
 * into them in its place — this module is no longer imported by either view,
 * kept only as documented sample data (its own `fixtures.test.ts`).
 *
 * `usersFixture` matches the count-only wire contract (ISSUE-455 Deliverable
 * 3, ADR-052 §3 amended 2026-09-18): the value is the live-verified dev
 * count (2026-09-18, `{"count":6}`), not a fabricated round number.
 * `documentsFixture` is unchanged and still exercises the channel asymmetry
 * (ADR-052 §3).
 */

export const usersFixture: UsersResponse = {
  count: 6,
};

export const documentsFixture: DocumentsResponse = {
  documents: [
    {
      documentId: "01J8Z3QK1N4R2X7S6T9V0W1Y2A",
      channel: "mobile",
      ownerRef: "entra#3fa85f64-5717-4562-b3fc-2c963f66afa6",
      status: "done",
      sizeBytes: 184320,
      // ISSUE-464: offset-suffixed, microsecond-precision — the real shape
      // the upstream Python producer emits (`datetime.isoformat()`), not the
      // all-Z shape every other fixture row uses. A fixture that only ever
      // used `Z` is what let the Z-only schema look correct in ISSUE-464.
      startedAt: "2026-08-29T07:40:00.123456+00:00",
      updatedAt: "2026-08-29T07:44:10.654321+00:00",
    },
    {
      documentId: "01J8Z3QK2P5S3Y8T7U0W1X2Z3B",
      channel: "telegram",
      ownerRef: "123456789",
      status: "indexing",
      sizeBytes: 92160,
      startedAt: "2026-08-30T17:58:02Z",
      updatedAt: "2026-08-30T18:02:55Z",
    },
    {
      documentId: "01J8Z3QK3Q6T4Z9U8V1X2Y3A4C",
      channel: "mobile",
      ownerRef: "entra#7c9e6679-7425-40de-944b-e07fc1f90ae7",
      status: "failed",
      sizeBytes: 512000,
      startedAt: "2026-09-01T11:55:10Z",
      updatedAt: "2026-09-01T11:56:40Z",
    },
    {
      documentId: "01J8Z3QK4R7U5A0V9W2Y3Z4B5D",
      channel: "telegram",
      ownerRef: "987654321",
      status: "done",
      sizeBytes: 3145728,
      startedAt: "2026-08-15T09:15:00Z",
      updatedAt: "2026-08-15T09:20:00Z",
    },
  ],
};
